import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';

import ActionButton from 'components/buttons/ActionButton';

import EditBenefitsDialog from './EditBenefitsDialog';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  label: {
    width: '150px',
  },
}));

const AddBenefitButton = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ActionButton startIcon={<AddIcon />} onClick={handleOpen} classes={{ label: classes.label }}>
        Add Benefit
      </ActionButton>
      {open && <EditBenefitsDialog open={open} onClose={handleClose} />}
    </>
  );
};

export default AddBenefitButton;
